import { FC } from 'react';

import { IMAGE_PLACEHOLDER } from '../../../../utils/variables';
import { Container, Description, HotelLogo, Title } from './CardDirector.styled';

export type CardDirectorProps = {
    logo?: string;
    cover: string;
    title?: string;
    description?: string;
}

export const CardDirector: FC<CardDirectorProps> = ({ logo, cover, title, description }) => (
  <Container cover={cover || IMAGE_PLACEHOLDER} data-testid="card-director">
    {logo && <HotelLogo src={logo || IMAGE_PLACEHOLDER} alt="hotel-logo" />}
    {title && <Title>{title}</Title>}
    {description && <Description>{description}</Description>}
  </Container>
);
